import Tag from "@shared/components/tag/Tag";
import { useExplore } from "@modules/new-explore/hooks/useExplore";
import {
  exploreFilterSchema,
  hasNonSharedExploreFilters,
} from "@modules/new-explore/schema";
import { ExploreSlugFilterSchema } from "@modules/new-explore/types";
import { useRouter } from "next/router";
import { EXPLORE_SLUG } from "types/api/explore";
import {
  TAG_COLOR,
  TAG_SIZE,
  TAG_STYLE,
  TAG_TYPE,
} from "@shared/components/tag";
import { useLayoutContext } from "@context/layout";
import useExplorePreloadedData from "@templates/new-explore/hooks/useExplorePreloadedData";

const ExploreTypeMobile = () => {
  const { query } = useRouter();
  const { isAdmin } = useLayoutContext();
  const {
    actions: { setActiveFilters },
  } = useExplorePreloadedData();
  const { addFilter, addFilters } = useExplore();
  const term = typeof query.term === "string" ? query.term : "";
  const data = (exploreFilterSchema.slug as ExploreSlugFilterSchema).data;
  const slug =
    typeof query.slug === "string" ? query.slug : EXPLORE_SLUG.COURSE;

  const handleClickOnItem = (id: EXPLORE_SLUG) => {
    if (term) {
      addFilters({
        data: [
          {
            filterName: "term",
            value: term,
            name: "",
          },
          {
            filterName: "slug",
            value: id,
            name: "",
          },
        ],
        isSingle: false,
        clear: true,
      });
    } else {
      addFilter({
        filterName: "slug",
        value: id,
        name: "",
        isSingle: false,
        withReplace: true,
        clear: true,
      });
    }
    setActiveFilters(undefined);
  };
  const resultTypeData = isAdmin
    ? data
    : data.filter((item) => item.name !== EXPLORE_SLUG.INSTRUCTOR);

  if (hasNonSharedExploreFilters(query)) return null;

  return (
    <div className=" w-full border-b px-4 border-fds-divider py-2 pl-2 flex gap-x-1  overflow-auto no-scrollbar  ">
      {resultTypeData.map(({ name, persian_name }, index) => (
        <Tag
          key={index}
          showTagClose={false}
          id={name}
          onClick={slug === name ? undefined : () => handleClickOnItem(name)}
          className="min-w-max px-2.5 text-sm w-full"
          style={slug === name ? TAG_STYLE.FILL : TAG_STYLE.LIGHT}
          size={TAG_SIZE.LARGE}
          color={slug === name ? TAG_COLOR.BRAND : TAG_COLOR.DEFAULT}
          type={TAG_TYPE.SQUARE}
        >
          {persian_name}
        </Tag>
      ))}
    </div>
  );
};

export default ExploreTypeMobile;
